import React, { useContext } from 'react';
import {
  Typography,
  ListItemIcon,
  Divider,
  MenuList,
  MenuItem
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ListIcon from '@mui/icons-material/ListAlt';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import PeopleIcon from '@mui/icons-material/People';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  language,
  features
} from '../config';
import logo192x192_white from '../assets/img/logo192x192_white.png'
import Firebase from '../api/Firebase';

function AppMenu(props) {
  const { api } = Firebase;
  const { isOpen, requestmodalclose } = props
  const {
    signOut
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const LogOut = () => {
    dispatch(signOut());
  };

  let isAdmin = auth.info && auth.info.profile && auth.info.profile.usertype === 'admin';
  let isFleetAdmin = auth.info && auth.info.profile && auth.info.profile.usertype === 'fleetadmin';
  let isOperator = auth.info && auth.info.profile && auth.info.profile.usertype === 'operator';
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#414cf7' }}>
        <img style={{ marginTop: '20px', marginBottom: '20px', width: '120px', height: '120px' }} src={logo192x192_white} alt="Logo" />
      </div>
      <Divider />
      <MenuList>
        {features.WebsitePagesEnabled ?
          <MenuItem component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.home}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin || isOperator ?
          <MenuItem component={Link} to="/dashboard" onClick={requestmodalclose}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.dashboard_text}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/bookings" onClick={requestmodalclose}>
            <ListItemIcon>
              <ListIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.booking_history}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/upcomingbookings" onClick={requestmodalclose}>
            <ListItemIcon>
              <ListIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.upcomingbookinglable}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/addbookings" onClick={requestmodalclose}>
            <ListItemIcon>
              <ListIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.addbookinglable}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/riders" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.riders}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin || isOperator ?
          <MenuItem component={Link} to="/drivers" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.drivers}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin ?
          <MenuItem component={Link} to="/operators" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.operator}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin || isOperator ?
          <MenuItem component={Link} to="/vehicles" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.vehicle}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin ?
          <MenuItem component={Link} to="/driverstatus" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.driverstatus}</Typography>
          </MenuItem>
          : null}
        {/* {isAdmin ?
          <MenuItem component={Link} to="/fleetadmins" onClick={requestmodalclose}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.fleetadmins}</Typography>
          </MenuItem>
          : null} */}
        {isAdmin ?
          <MenuItem component={Link} to="/cartypes" onClick={requestmodalclose}>
            <ListItemIcon>
              <CarIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.car_type}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/transactions" onClick={requestmodalclose}>
            <ListItemIcon>
            <MoneyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.transactions}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/cancelreasons" onClick={requestmodalclose}>
            <ListItemIcon>
              <CarIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.cancellation_reasons}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/earningreports" onClick={requestmodalclose}>
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.earning_reports}</Typography>
          </MenuItem>
          : null}
        {isAdmin || isFleetAdmin ?
          <MenuItem component={Link} to="/driverearning" onClick={requestmodalclose}>
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.driver_earning}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/addtowallet" onClick={requestmodalclose}>
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.add_to_wallet}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/withdraws" onClick={requestmodalclose}>
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.withdraws}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/promos" onClick={requestmodalclose}>
            <ListItemIcon>
              <OfferIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.promo}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/notifications" onClick={requestmodalclose}>
            <ListItemIcon>
              <NotifyIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.push_notification_title}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/settings" onClick={requestmodalclose}>
            <ListItemIcon>
              <LocalAtmIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.settings_title}</Typography>
          </MenuItem>
          : null}
        {isAdmin ?
          <MenuItem component={Link} to="/fare" onClick={requestmodalclose}>
            <ListItemIcon>
              <LocalAtmIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.fare_title}</Typography>
          </MenuItem>
          : null}
             {isAdmin ?
          <MenuItem component={Link} to="/delete-requests" onClick={requestmodalclose}>
            <ListItemIcon>
              <LocalAtmIcon />
            </ListItemIcon>
            <Typography variant="inherit">{language.delete}</Typography>
          </MenuItem>
          : null}
        <MenuItem component={Link} to="/profile" onClick={requestmodalclose}>
          <ListItemIcon>
            <PersonOutlineIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.profile}</Typography>
        </MenuItem>
        <MenuItem onClick={LogOut}>
          <ListItemIcon>
            <ExitIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.logout}</Typography>
        </MenuItem>
      </MenuList>
    </div>
  );
}

export default AppMenu;